import { neftApi } from "app/config";

import { removeEmptyValue } from "utils";
import { ApiTableResponse, TransactionDTO } from "models";
import { IDownloadReportParams, ITransactionReportParams } from "pages/Report/models";

// type NotificationType = "success" | "info" | "warning" | "error";

const reportApiWithTag = neftApi.enhanceEndpoints({
  addTagTypes: ["transaction-batch"],
});

const reportApiSlice = reportApiWithTag.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getTransactionReport: builder.query<ApiTableResponse<TransactionDTO>, ITransactionReportParams>(
      {
        query: (transactionParams) => ({
          url: `/transaction/search`,
          method: "GET",
          params: removeEmptyValue(transactionParams),
        }),
        providesTags: [{ type: "transaction-batch" as const }],
      },
    ),

    downloadSettlementReport: builder.mutation<any, IDownloadReportParams>({
      queryFn: async ({ fileName, ...reportParams }, api, extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: `/transaction/settlement/report/csv`,
          params: removeEmptyValue(reportParams),
          method: "GET",
          responseHandler: (response) => response.blob(),
        });
        const modifiedReportParams = removeEmptyValue(reportParams);

        const url = window.URL || window.webkitURL;
        const hiddenLink = document.createElement("a");
        hiddenLink.target = "_blank";
        const blobDocument = url.createObjectURL(result?.data as any);

        hiddenLink.href = blobDocument as any;
        hiddenLink.download = `${fileName}_${modifiedReportParams.merchant || ""}_${
          modifiedReportParams.startDate || ""
        }_${modifiedReportParams.endDate || ""}_${modifiedReportParams.sortCode || ""}`;
        hiddenLink.click();

        return { data: null };
      },
    }),
  }),
});

export const {
  useGetTransactionReportQuery,
  useLazyGetTransactionReportQuery,
  useDownloadSettlementReportMutation,
} = reportApiSlice;

export default reportApiSlice;
